// extracted by mini-css-extract-plugin
module.exports = {"results_section":"style_results_section__3W6mx","results_section__container":"style_results_section__container__6PO1-"};